import type { Editor, Range } from "@tiptap/react";

import type { PollResponse } from "./api";

export interface PollModalProps {
  addToLocalSgidToObjectMap: (params: {
    sgid: string;
    object: PollResponse;
  }) => void;
  editor: Editor;
  range: Range;
}

export interface EditPollModalProps {
  pollSgid: string;
}

export const POLL_FORM_ID = "poll-form-compass";
